export default "__VITE_ASSET__DY6gFNb5__"